module.exports = __webpack_public_path__ + "static/media/icefields-24.523f77a1.jpg";